import type { JSX } from "react";

import { Flex, Group, Stack, Text } from "@mantine/core";

import { ListeningAnimation } from "@/common-ui";
import { getListeningText } from "@/customer-panel/components/customer-insights/listening/services/getListeningText";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { ChipRow } from "@/sales-tools/detected-cues/components/ChipRow";
import { sortCues } from "@/sales-tools/detected-cues/services/sortCues";
import { useDetectedCuesStore } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";
import { useSessionId } from "@/sdk";

import classes from "./DetectedCues.module.css";

export function DetectedCues(): JSX.Element | null {
    const sessionId = useSessionId();
    const cues = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));
    const hasSoftwareCues = !!cues.find((c) => c.type === "SOFTWARE");
    const hasDevicesCues = !!cues.find((c) => c.type === "DEVICE");
    const { isDigitalCompetencyInsightEnabled } = usePartnerFeatureConfigured();

    return (
        <Stack id="detected-devices-container" className={classes.text} gap="xs">
            {hasDevicesCues && (
                <>
                    <Stack gap="xs">
                        <Text size="0.75rem" fw="700" c="dark.2">
                            Devices
                        </Text>
                        <Group align="center" gap={4} wrap="nowrap">
                            <Text size="0.75rem" c="dark.2">
                                {getListeningText(cues, isDigitalCompetencyInsightEnabled)}
                            </Text>
                            {!isDigitalCompetencyInsightEnabled && <ListeningAnimation style={{ width: "1rem" }} />}
                        </Group>
                    </Stack>
                    <Flex className={classes.chipContainer} direction="row">
                        <ChipRow chips={sortCues(cues.filter((c) => c.type === "DEVICE"))} />
                    </Flex>
                </>
            )}
            {hasSoftwareCues && (
                <>
                    <Text size="0.75rem" fw="700" c="dark.2">
                        Software
                    </Text>
                    <Flex className={classes.chipContainer} direction="row">
                        <ChipRow chips={sortCues(cues.filter((c) => c.type === "SOFTWARE"))} />
                    </Flex>
                </>
            )}
        </Stack>
    );
}
